import { useState, useEffect, useCallback } from 'react';
import { DocumentTemplateRead, DocumentTypeRead } from '../types';
import { fetchTemplates, fetchDocumentTypes, deleteTemplate } from '../api';

export function useTemplates() {
  const [templates, setTemplates] = useState<DocumentTemplateRead[]>([]);
  const [types, setTypes] = useState<DocumentTypeRead[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [fetchedTemplates, fetchedTypes] = await Promise.all([
        fetchTemplates(),
        fetchDocumentTypes()
      ]);
      setTemplates(fetchedTemplates);
      setTypes(fetchedTypes);
    } catch (err: any) {
      setError(err.message || 'Ошибка загрузки данных');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const removeTemplate = async (id: number) => {
    try {
      await deleteTemplate(id);
      setTemplates(prev => prev.filter(t => t.id !== id));
    } catch (err: any) {
      alert(`Ошибка удаления: ${err.message}`);
    }
  };

  return { templates, types, loading, error, refresh: loadData, removeTemplate };
}